<template>
    <CustomDialog v-model="isVisible" :defaultTitle="isEditMode ? $t('pos.edit') : $t('pos.add')" width="900px">
        <template #content>
            <div class="noGapMobile ppv2-flex md:ppv2-flex-row ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                <CustomInput
                    :label="$t('pos.device_id_label')"
                    v-model="form.device_id"
                    :placeholder="$t('pos.device_id_placeholder')"
                    :required="true"
                    :readonly="isEditMode"
                    :errorText="errors.device_id"
                    :customLabelStyle="`font-size: ${normalizeSize(15, true)}`"
                    customLabelClass="poppinsLight ppv2-text-black"
                />
                <CustomInput
                    :label="$t('pos.device_name_label')"
                    :required="true"
                    :errorText="errors.device_name"
                    v-model="form.device_name"
                    :placeholder="$t('pos.device_name_placeholder')"
                    :customLabelStyle="`font-size: ${normalizeSize(15, true)}`"
                    customLabelClass="poppinsLight ppv2-text-black"
                />
            </div>
            <div class="noGapMobile ppv2-flex md:ppv2-flex-row ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                <!-- <CustomInput
                    label="Fond de caisse"
                    v-model="form.cash_fund"
                    type="number"
                    placeholder="0.00"
                    :customLabelStyle="`font-size: ${normalizeSize(15, true)}`"
                    customLabelClass="poppinsLight ppv2-text-black"
                /> -->
                <div class="ppv2-mt-2 ppv2-flex">
                    <div class="ppv2-inline-flex ppv2-items-end ppv2-gap-3 ppv2-px-4 ppv2-mb-[20px]">
                        <BaseSwitch
                            :label="$t('pos.status_label')"
                            v-model="form.is_active"
                            :boxed="true"
                            variant="success"
                            :customLabelStyle="`font-size: ${normalizeSize(15, true)}`"
                            customLabelClass="poppinsLight ppv2-text-black"
                        />
                    </div>
                </div>
            </div>
        </template>

        <template #actions>
            <BaseButton variant="outline" @click="cancel" :customHeight="48" customClass="!ppv2-min-w-[160px]">
                {{ $t('common.cancel') }}
            </BaseButton>
            <BaseButton
                variant="primary"
                :loading="isSaving"
                @click="save"
                :customHeight="48"
                customClass="!ppv2-min-w-[160px] !ppv2-bg-[#7D2DBD] hover:!ppv2-bg-[#6b26a3]"
            >
                {{ isEditMode ? $t('common.validate') : $t('common.add') }}
            </BaseButton>
        </template>

        <!-- Exit Dialog -->
        <CustomDialog
            v-model="showExitPopup"
            :defaultTitle="$t('pos.exit_title')"
            heightClass="ppv2-max-h-[40vh]"
            :persistent="true"
        >
            <template #content>
                <p class="ppv2-text-center ppv2-text-black poppinsRegular" :style="{ fontSize: normalizeFontSize(15) }">
                    {{ $t('pos.exit_message') }}
                </p>
            </template>
            <template #actions>
                <BaseButton variant="outline" @click="exit">{{ $t('pos.exit_confirm') }}</BaseButton>
                <BaseButton variant="primary" @click="showExitPopup = false">{{ $t('pos.exit_cancel') }}</BaseButton>
            </template>
        </CustomDialog>
    </CustomDialog>
</template>

<script>
import CustomInput from '../../Inputs/CustomInput.vue'
import BaseButton from '../../Shared/BaseButton.vue'
import BaseSwitch from '../../Shared/BaseSwitch.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'
import normalizeSize from '../../../utils/normalizeSize'
import axios from 'axios'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    name: 'POSForm',
    components: {
        CustomInput,
        BaseButton,
        BaseSwitch,
        CustomDialog,
    },
    props: {
        value: { type: Boolean, default: false },
        posData: { type: Object, default: () => null },
        userId: { type: [Number, String], default: null },
        token: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isSaving: false,
            showExitPopup: false,
            form: {
                id: null,
                device_id: '',
                device_name: '',
                cash_fund: 0,
                is_active: true,
            },
            errors: {},
            initialForm: null,
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        isEditMode() {
            return !!(this.posData && this.posData.id)
        },
    },
    watch: {
        posData: {
            handler(newVal) {
                if (newVal) {
                    this.initForm()
                } else {
                    this.resetForm()
                }
                this.initialForm = JSON.stringify(this.form)
            },
            immediate: true,
        },
        isVisible(newVal) {
            if (newVal && !this.isEditMode) {
                this.resetForm()
                this.initialForm = JSON.stringify(this.form)
            }
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        initForm() {
            this.form = {
                id: this.posData.id,
                device_id: this.posData.device_id || '',
                device_name: this.posData.device_name || '',
                // cash_fund: this.posData.cash_fund || 0,
                is_active: !!this.posData.is_active,
            }
        },
        resetForm() {
            this.form = {
                id: null,
                device_id: '',
                device_name: '',
                // cash_fund: 0,
                is_active: true,
            }
            this.errors = {}
        },
        cancel() {
            if (JSON.stringify(this.form) !== this.initialForm) {
                this.showExitPopup = true
            } else {
                this.exit()
            }
        },
        exit() {
            this.showExitPopup = false
            this.isVisible = false
            this.$emit('close')
        },
        validateForm() {
            this.errors = {}
            let isValid = true

            if (!this.form.device_id) {
                this.errors.device_id = this.$t('pos.validation_device_id')
                isValid = false
            }

            if (!this.form.device_name) {
                this.errors.device_name = this.$t('pos.validation_device_name')
                isValid = false
            }

            return isValid
        },
        async save() {
            if (!this.validateForm()) {
                return
            }

            this.isSaving = true
            try {
                const url = this.isEditMode ? `/api/v3/pos/update/${this.form.id}` : '/api/v3/pos/create'
                const method = this.isEditMode ? 'put' : 'post'

                const data = {
                    ...this.form,
                }

                await axios[method](url, data, {
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                    },
                })
                this.$toast.success(this.$t('pos.save_success'))
                this.initialForm = JSON.stringify(this.form)
                this.$emit('success')
                this.exit()
            } catch (error) {
                this.$toast.error(error.response.data.message)
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                this.$toast.error(this.$t('common.save_error'))
            } finally {
                this.isSaving = false
            }
        },
    },
}
</script>

<style scoped lang="scss">
:deep(.v-card) {
    border-radius: 10px !important;
}
@media (max-width: 768px) {
    .noGapMobile {
        gap: 0 !important;
    }
}
</style>
